import Sidebar from './Sidebar';
import Topbar from './Topbar';
import MaterialManagement from './MaterialManagement';

const AdminMaterials = () => {
  return (
    <div className="flex min-h-screen bg-[#f5f6fa]">
        <Sidebar />
        <div className="flex flex-col flex-1">
            <Topbar />
            <MaterialManagement />
        </div>
    </div>
  );
};

export default AdminMaterials;